import { FC } from 'react'

import FormikField from '../FormikField'
import FormikForm, { FormikFormProps } from '../FormikForm'
import { FormFieldTextAreaProps } from '../fields/FormFieldTextArea'
import { FormFieldStarPickerProps } from '../fields/FormFieldStarPicker'
import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { FormSubmitButtonProps } from '../FormSubmitButton'

import * as SC from './styled'

export type FormReviewProps = FormikFormProps & {
  fields: {
    starPicker: Omit<FormFieldStarPickerProps, 'name' | 'value'>
    message: Omit<FormFieldTextAreaProps, 'name'>
  }
  texts?: {
    button?: string
  }
  value?: string
  submitButton?: FormSubmitButtonProps
}

const FormReview: FC<FormReviewProps> = ({
  texts,
  fields,
  submitButton,
  ...formikProps
}) => {
  const { starPicker, message } = fields

  return (
    <FormikForm {...formikProps}>
      <FormikField
        {...starPicker}
        name={'stars'}
        Component={SC.StarPickerField}
        required
      />
      <FormikField
        {...message}
        name={'review'}
        Component={SC.TextAreaField}
        required
      />
      <SC.ButtonWrapper>
        <SC.SubmitButton
          {...submitButton}
          text={texts?.button}
          type={'submit'}
          variant={ActionButtonVariant.tertiary}
        />
      </SC.ButtonWrapper>
    </FormikForm>
  )
}

export default FormReview
